import styled from 'styled-components';
import Card from './ui/Card';

const ItemCard = styled(Card)`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1.5rem;

  &:hover {
    border-color: ${({ theme }) => theme.colors.pink};
    box-shadow: ${({ theme }) => theme.glow.pink};
  }
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
`;

const Name = styled.h3`
  font-family: ${({ theme }) => theme.fonts.display};
  font-size: 1.1rem;
  text-transform: none;
  letter-spacing: 0.02em;
  margin: 0;
`;

const Price = styled.span`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text};
  white-space: nowrap;
  background: ${({ theme }) => theme.colors.gold};
  padding: 0 0.35em;
`;

const Description = styled.p`
  margin: 0;
  font-size: 0.9rem;
`;

function MenuItemCard({ item }) {
  return (
    <ItemCard>
      <Row>
        <Name>{item.nombre}</Name>
        <Price>${Number(item.precio).toFixed(2)}</Price>
      </Row>
      {item.descripcion && <Description>{item.descripcion}</Description>}
    </ItemCard>
  );
}

export default MenuItemCard;
